
import * as React from 'react';
import styled from 'styled-components';

import { Modal } from '@process-advisor/process-miner/components/modal/modal';
import { NumberInput } from '@process-advisor/process-miner/components/shared/numberInput';
import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { Text} from '@process-advisor/process-miner/modals/text';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { Event } from '@process-advisor/process-miner/api/events';
import { type StepCostModalProps } from '@process-advisor/process-miner/api/methods/modals/stepCostModal';
import { getShadow } from '@process-advisor/process-miner/shared/theme';
import { Section } from '@process-advisor/process-miner/modals/section';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

const Wrapper = styled.div`
    display: grid;
    align-items: center;
    grid-template-columns: 200px 300px;
    grid-gap: 10px;

    padding: 15px 20px 15px 15px;
    box-shadow: ${getShadow('pane')};
`;

const ReductionWrapper = styled.div`
    display: grid;
    align-items: baseline;
    grid-gap: 10px;
    grid-template-columns: 200px 80px 100px;
    padding: 0px 20px 0px 0px;
`;

const costTypes = [
    { value: 'fixed-cost', label: 'Fixed Cost' },
    { value: 'perday', label: 'Per day' },
    { value: 'perhour', label: 'Per hour' },
    { value: 'perminute', label: 'Per minute' },
];
const issueTypes = [
    { value: 'all_issues', label: 'All' },
    { value: 'filtered_issues', label: 'Filtered' },

];
const variantTypes = [
    { value: 'all_variants', label: 'All variants' },
    { value: 'selected_variants', label: 'Selected variants' },
];

const durationValues = [
    { value: 'secs', label: 'secs' },
    { value: 'mins', label: 'mins' },
    { value: 'hrs', label: 'hrs' },
    { value: 'days', label: 'days' },
];

const reductionTypes = [
    { value: 'N/A', label: 'N/A' },
    { value: 'fixed-cost', label: 'Fixed Cost' },
    { value: 'duration-actual', label: 'Duration - Actual' },
    { value: 'duration-percentage', label: 'Duration - %' },
];


export const StepCostModal = () => {
    const [data, setData] = React.useState<{ description: string, fromActivity: string, toActivity: string, mode: string, cost: number,  costType: string, variantType: string, issueType: string , reductionType: string, reductionPercentage: number, reductionDuration: number,reductionCost: number, reductionValue: string}
    >({ description: '', fromActivity: '', toActivity: '', mode: '', cost: 0,  costType: '', variantType: '', issueType: '' , reductionType: '', reductionPercentage: 0, reductionCost: 0, reductionDuration: 0, reductionValue: ''});
    const [isOpen, setIsOpen] = React.useState(false);
    const [cost, setCost] = React.useState(0);
    const [costType, setCostType] = React.useState<string>('fixed-cost');
    const [issueType, setIssueType] = React.useState<string>('all');
    const [variantType, setVariantType] = React.useState<string>('all_variants');
    const [description, setDescription] = React.useState<string>('');
    const [typeLabel, setTypeLabel] = React.useState<string>('Fixed cost per event');
    const [type, setType] = React.useState<string>('direct');
    const [attribute, setAttribute] = React.useState<string>('');
    const [validData, setValidData] = React.useState<boolean>(false);

    const [costID, setCostID] = React.useState<number>(0);
    const [reductionType, setReductionType] = React.useState<string>('percentage');
    const [reductionPercentage, setReductionPercentage] = React.useState<number>(100);
    const [reductionCost, setReductionCost] = React.useState<number>(0);
    const [reductionDuration, setReductionDuration] = React.useState<number>(0);
    const [reductionValue, setReductionValue] = React.useState<string>('hrs');
    
    React.useEffect(() => {

    }, []);
    
    useApiListener(
        Event.openStepCostModal,
        ({ data }: StepCostModalProps) => {
            setIsOpen(true);
            setData(data);
            setDescription(data.description);
            setVariantType(data.variantType);
            setIssueType(data.issueType);
            setCostID(data.costID)
            setCostType(data.costType);
            setCost(data.cost);
            setAttribute(data.attribute);
            setReductionType(data.reductionType)
            setReductionPercentage(data.reductionPercentage)
            setReductionCost(data.reductionCost)
            setReductionDuration(data.reductionDuration)
            setReductionValue(data.reductionValue)
            onCostTypeChange(data.costType);
            if (data.mode === 'edit') setValidData(true);
        }
    );
    const min = 0;

    const onOk = () => {
        apiProvider.updateStepCost({
                description,
                cost: cost,
                costType,
                variantType,
                issueType,
                fromActivity: data.fromActivity,
                toActivity: data.toActivity,
                mode: data.mode,
                type: 'step',
                costID: costID,
                attribute: attribute,
                reductionType: reductionType,
                reductionPercentage: reductionPercentage,
                reductionCost: reductionCost,
                reductionDuration: reductionDuration,
                reductionValue: reductionValue
            })
    };

    const onCostTypeChange = (type: string) => {
        setCostType(type);
        setType('direct')
        if (type === 'fixed-cost') { setTypeLabel('Fixed cost per event')}
        if (type === 'perday') { setTypeLabel('Cost per day')}
        if (type === 'perhour') { setTypeLabel('Cost per hour')}
        if (type === 'perminute') { setTypeLabel('Cost per minute')}
    };

    const onVariantTypeChange = (type: string) => {
        setVariantType(type);
    };

    const onIssueTypeChange = (type: string) => {
        setIssueType(type);
    };

    const onCostChange = (cost: string) => {
        setCost(Number(cost));
        if (Number(cost) > 0 && description !== '') {setValidData(true)} else {setValidData(false)}
    };

    const onDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDescription(event.target.value);
        if (event.target.value !== '' && cost > 0) {setValidData(true)} else {setValidData(false)}
    };

    const onReductionValueChange = (value: string) => {
        setReductionValue(value);
    };

    const onReductionTypeChange = (type: string) => {
        setReductionType(type);
    };

    return (
        <Modal title='Step Cost' open={isOpen} onClose={() => setIsOpen(false)} onOk={onOk} saveOK={validData} width=''>
            <Wrapper>
                <Section title='Cost'/>
                <Text multiline maxRows={5} value={description} onChange={onDescriptionChange}/>
                <Section title='Variants'/>
                <Dropdown label='' value={variantType} onChange={onVariantTypeChange} options={variantTypes} />
                <Section title={apiProvider.getEntityUpper() + 's'}/>
                <Dropdown label='' value={issueType} onChange={onIssueTypeChange} options={issueTypes} />
                <Section title='Actual Cost Calculation'/>
                <Dropdown label='' value={costType} onChange={onCostTypeChange} options={costTypes} />
                <Section title={typeLabel}/>
                <NumberInput label='' value={cost} onChange={onCostChange} min={min} />
                <Section title='Forecast Cost Calculation'/>
                    <Dropdown label='' value={reductionType} onChange={onReductionTypeChange} options={reductionTypes} />
                    { reductionType === 'fixed-cost' ?
                    <ReductionWrapper>
                        <Section title='Fixed Cost'/>
                        <NumberInput label='' value={reductionCost} min={0} onChange={setReductionCost}/>
                    </ReductionWrapper>
                    : '' }    
                    { reductionType === 'duration-percentage' ?
                    <ReductionWrapper>
                        <Section title='Reduce Percentage Duration'/>
                        <NumberInput label='' value={reductionPercentage} min={0} max={100} onChange={setReductionPercentage}/>
                    </ReductionWrapper>
                    : '' }
                    { reductionType === 'duration-actual' ?
                    <ReductionWrapper>
                        <Section title='Reduce Actual Duration'/>
                        <NumberInput label='' value={reductionDuration} min={0} onChange={setReductionDuration}/>
                        <Dropdown label='' value={reductionValue} onChange={onReductionValueChange} options={durationValues} />         
                    </ReductionWrapper>
                    : '' }    

            </Wrapper>
        </Modal>
    );
};
